import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SalesPeopleService } from "../salespeople.service";
  
  @Component({
    selector: 'app-showdrawguaranteehistory-screen',
    templateUrl: './showdrawguaranteehistory.screen.component.html',
    styleUrls: ['./showdrawguaranteehistory.screen.component.scss'],
    providers: [SalesPeopleService],
    standalone: false
})
export class ShowDrawGuaranteehistoryScreenComponent implements OnInit {
  @Input() historicalData: any; // Historical data passed from the parent component
  parsedHistory: any[] = [];
  isLoading: boolean = true;

constructor(
  private activeModal: NgbActiveModal,
  private _salesPeopleService: SalesPeopleService,
) {}

ngOnInit(): void {
  this.showDrawGuaranteeHistory();
}
closePopup() {
  this.activeModal.close({});
}

showDrawGuaranteeHistory() {
  const data = {
        historyId: this.historicalData.historyId,
        historyType: this.historicalData.historyType,
      };

      this._salesPeopleService.getDrawGuaranteeHistoricalChanges(data).subscribe(
        (response) => {
          const history = response.data;
    
          // Parse the JSON string inside `historyData` field
          this.parsedHistory = history.map(item => ({
            ...item,
            historyData: typeof item.historyData === 'string'? JSON.parse(item.historyData) : item.historyData
          }));
          this.isLoading = false; // <- turn off loading
         
        },
        (error) => {
          console.error("Error fetching historical data:", error);
          this.isLoading = false; // <- turn off loading
        }
      );
}
}